import {Form, Input, InputNumber, message, Modal, ModalProps} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import {errorMessage} from 'Utils/common';
import useRequestFn from 'Utils/Hooks/useRequestFn';
import SelectDict from 'Features/Select/SelectDict';
import {editOperate, OperateEntityItem} from '../../service';
import {useDict} from '../../../../../../store';

interface Props extends ModalProps {
    data?: OperateEntityItem;
    catid: string;
    onOk: () => void;
}

const Index = ({data, catid, onOk, ...props}: Props) => {
    const dict = useDict();
    const [form] = Form.useForm<OperateEntityItem>();
    const [save, {loading: saveLoading}] = useRequestFn(editOperate);

    async function onFinish(formData: OperateEntityItem) {
        try {
            if (data) {
                formData.id = data.id;
            }
            formData.catid = catid;
            await save(formData);
            message.success('编辑成功!');
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <Modal
            {...props}
            width={800}
            title="编辑栏目"
            confirmLoading={saveLoading}
            onOk={form.submit}>
            <div className={Style.root}>
                <Form
                    form={form}
                    onFinish={onFinish}
                    labelCol={{span: 6}}
                    initialValues={data}>
                    <Form.Item
                        name="actionName"
                        label="操作名称"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="isPage"
                        label="翻页动作"
                        initialValue={dict.IsPageType.firstValue}
                        rules={[{required: true}]}>
                        <SelectDict options={dict.IsPageType.data} />
                    </Form.Item>
                    <Form.Item
                        name="pageType"
                        label="页面类型"
                        initialValue={dict.IsPageType.firstValue}
                        rules={[{required: true}]}>
                        <SelectDict options={dict.OperateType.data} />
                    </Form.Item>
                    <Form.Item
                        name="actionTextValue"
                        label="动作元素内容"
                        help="actionTextValue"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="actionValue"
                        label="操作值"
                        help="actionValue"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="actionXpath"
                        label="操作元素xpath"
                        help="actionXpath"
                        rules={[{required: true}]}>
                        <Input.TextArea placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="actionEvent"
                        label="操作事件"
                        help="actionEvent"
                        rules={[{required: true}]}>
                        <Input placeholder="请输入" />
                    </Form.Item>
                    <Form.Item
                        name="listorder"
                        label="操作次序"
                        help="listorder"
                        rules={[{required: true}]}>
                        <InputNumber placeholder="请输入" />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default Index;
